module.exports = __webpack_public_path__ + "img/tb1041-5-1974.prt.de8d56ac.jpg";